import { useTranslation } from "react-i18next";
import { Button } from "components/button";
import { Tooltip } from "components/tooltip";
import { useAnalytics } from "contexts/AnalyticsContext";

interface OpenAmplifyProjectButtonProps {
  amplifyProjectId: string | null | undefined;
}

export const OpenAmplifyProjectButton = ({
  amplifyProjectId,
}: OpenAmplifyProjectButtonProps) => {
  const { t } = useTranslation(["projectDetails"]);
  const { gaEvent } = useAnalytics();
  const label = t("projectDetails:buttons.openAmplifyProject.label");

  if (!amplifyProjectId) {
    return (
      <Tooltip
        content={t("projectDetails:buttons.openAmplifyProject.disabledTooltip")}
      >
        {/* A disabled button ignores pointer events, so the span receives the hover. */}
        <span className="inline-flex cursor-not-allowed">
          <Button variant="tertiary" icon="external-link" disabled>
            {label}
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      asChild
      variant="tertiary"
      icon="external-link"
      onClick={() =>
        gaEvent({ type: "project_amplify_project_opened", payload: {} })
      }
    >
      <a
        href={`${import.meta.env.VITE_AMPLIFY_APP_URL}/projects/${amplifyProjectId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>
    </Button>
  );
};
